import React from "react";
import { Flex } from "../../components/Flex";
import { ProgressBar } from "../../components/Progress";
import { Paragraph } from "../../components/Text";
import { ArrowBackIcon } from "../../icons/ArrowBackIcon";
import { CloseIcon } from "../../icons/CloseIcon";


const UploadProgressRow = ({ name, progress, status, onCancel, onReload }) => {

    return(
        <Flex direction="column" gap={{ bottom: 4 }}>
            <Paragraph style={{ fontWeight: 700 }}>{name}</Paragraph>
            {status === 3
                ? <Flex align="center">
                    <ProgressBar progress={progress} status={status} />
                    {onCancel ? <CloseIcon size={24} color="var(--sp-error-color)" hoverColor="var(--sp-error-hover-color)" onClick={onCancel} /> : null}
                    {onReload ? <ArrowBackIcon onClick={onReload} /> : null }
                </Flex>
                : status < 0
                    ? <Paragraph color="var(--sp-error-hover-color)">Failed</Paragraph>
                    : status === 1
                        ? <Paragraph color="var(--sp-error-hover-color)">Canceled</Paragraph>
                        : <Paragraph color="var(--sp-success-color)">Done</Paragraph>
            }
        </Flex>
    );
};

export { UploadProgressRow };